import { DialogController } from 'aurelia-dialog';
import { EntityController } from 'pages/entity/entity-controller';
import { autoinject } from 'aurelia-framework';
import { Item } from 'data/entities/entities';
import { MetadataService } from 'data/service/meta-data-service';
import { ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'core/bootstrap-form-renderer';

@autoinject()
export class AddNewItemDialog {

	title = "Add New Item";
	controller: EntityController;
	item: Item;

	constructor(
		private dialogController: DialogController,
		private metadataService: MetadataService,
		private validationController: ValidationController,
		private bootstrapFormRenderer: BootstrapFormRenderer
	) {
		this.dialogController.settings.lock = true;
		this.validationController.addRenderer(bootstrapFormRenderer);
	}

	async validateItem() {

		const result = await this.validationController.validate();
		if (result.valid) {
			// validation succeeded
			console.log("success");
			this.dialogController.ok();
		} else {
			console.log("failure");
			// validation failed
		}
	}


	activate(model: Item) {
		this.item = model;

	}
}